import React from "react";
import Input from '../../elements/input';
import './styles.scss';

const SearchFilter = (props) => {
  return (
    <div className="search-input">
      <Input
        name={props?.name}
        type="text"
        variant="outlined"
        title={props?.title || "Search"}
        placeholder={props?.placeholder || "Search by name, email"}
        InputLabelProps={{
          shrink: false,
        }}
        onKeyDown={(e) => {
          if(e?.keyCode === 13) props?.handleChange(e);
        }}
        size="small"
        value={props?.selectedData || ""}
        onChange={props?.handleChange}
      />
    </div>
  )
}

export default SearchFilter
